import { NetLogicPaymentMethod } from "./NetLogicPaymentMethod";

export class NetLogicPayment {
  constructor(order) {
    this.order = order;

  }

  get methods() {
    const payer = {
      amount: this.order.total,
      tenderMedia: this.order.tenderMedia,
    };
    const customerMethod = new NetLogicPaymentMethod(payer);

    return [customerMethod.export()];
  }

  export() {
    return this.methods;
  }
}
